import { ProductDetailPageProps } from '@/types/ProductDetailPageProps';
import { pseudoI18n } from '@/i18n/pseudoI18n';
import { Brand } from '@/payload-types';
import { clsx } from 'clsx';

type IProductMainInfoProps = ProductDetailPageProps & {
  selectedVariant?: string;
  setSelectedVariant: (variant: string) => void;
};

export default function ProductMainInfo(props: IProductMainInfoProps) {
  const { product, selectedVariant, setSelectedVariant } = props;
  if (!product) return null;

  const { t } = pseudoI18n();

  const { productName, productCode, brand, variants } = product || {};

  const onSelectVariantWrapper = (variantId: string) => {
    return () => {
      if (selectedVariant === variantId) {
        setSelectedVariant('');
      } else {
        setSelectedVariant(variantId);
      }
    };
  };

  const productSKU = selectedVariant
    ? variants?.find(v => v.id === selectedVariant)?.variantCode || productCode
    : productCode;

  return (
    <div className="flex flex-col gap-y-4">
      <h1 className="text-h5 font-bold">{productName}</h1>
      <p>
        {t('SKU')}: <strong>{productSKU || '-'}</strong>
      </p>
      <p>
        {t('Brand')}: <strong>{(brand as Brand)?.title || '-'}</strong>
      </p>
      <div className="flex items-center gap-6">
        <p>{t('Variant')}</p>
        {!variants?.length && '-'}
        {Boolean(variants?.length) && (
          <ul className='flex flex-wrap gap-2'>
            {variants?.map(variant => (
              <li key={variant.id}>
                <button
                  className={clsx(
                    'py-2 px-4 border border-neutral-100 rounded-lg cursor-pointer',
                    'delay-100 transition-all duration-500',
                    'hover:border-neutral-400',
                    selectedVariant === variant.id && 'border-secondary-200'
                  )}
                  onClick={onSelectVariantWrapper(variant.id as string)}
                >
                  {variant.variantTitle}
                </button>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
}
